import { post, get, patch } from './axios'
import type { Http as HttpI } from '../domain/http'
export const http: HttpI = {
  post,
  get,
  patch
}
